<div class="map-calculator" *ngIf="items.length > 0 || isAdmin" id="map-calculator">
  <div class="calculator-header">
    <h2 *ngIf="selectedItems.length > 0 || isAdmin || items.length > 0">Cost Estimator</h2>
    <button class="btn btn-primary btn-sm add-item-btn" *ngIf="isAdmin" (click)="openAddItemModal(addItemModal)"><i class="fas fa-plus"></i>Add Item</button>
  </div>

  <!-- Items List as Tags -->
  <div class="items-section" *ngIf="items.length > 0">
    <!-- <h3>Available Items</h3> -->
    <div class="items-tags">
      <div class="item-tag" *ngFor="let item of items" [class.selected]="isItemSelected(item.id)" (click)="selectItem(item)">
        <span class="tag-name">{{ item.name }}</span>
        <span class="tag-price" *ngIf="isAdmin">${{ item.price }}/{{ item.unit }}</span>
        <button class="btn-remove-tag" *ngIf="isAdmin" (click)="removeItem(item.id); $event.stopPropagation()">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
  <!-- Selected Items & Calculation -->
  <div class="calculation-section" *ngIf="selectedItems.length > 0">
    <div class="selected-items">
      <div class="selected-item" *ngFor="let selected of selectedItems">
        <div class="item-info">
          <h4>{{ selected.item.name }}</h4>
        </div>

        <div class="quantity-section">
          <div class="number-input-group">
            <label>{{ selected.item.unit ?? "Quantity" }}:</label>
            <input type="number" [value]="selected.quantity" (input)="selected.item.type === 'range' ? updateRangeQuantity(selected.item.id, +$event.target.value) : updateQuantity(selected.item.id, +$event.target.value)" min="1" class="quantity-input" />
          </div>
        </div>

        <div class="item-total">
          <span class="total-label">Total:</span>
          <span class="total-value">{{ getRangeTotalDisplay(selected) }}</span>
        </div>

        <button class="btn-remove-selected" *ngIf="isAdmin" (click)="removeSelectedItem(selected.item.id)">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Item Modal -->
<ng-template #addItemModal let-modal>
  <div class="add-item-modal">
    <div class="add-item-modal__header">
      <h5 class="add-item-modal__title">
        <i class="fa-solid fa-plus me-2"></i>
        Add New Item
      </h5>
      <button class="add-item-modal__close" (click)="closeModal()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="add-item-modal__body">
      <form class="add-item-form" #addItemForm="ngForm">
        <div class="form-group">
          <label for="itemName">Item Name *</label>
          <input type="text" id="itemName" [(ngModel)]="newItem.name" (input)="onInputChange('name', $event.target.value)" name="itemName" class="form-control" placeholder="Enter item name" required />
        </div>

        <div class="form-row px-2">
          <div class="form-group">
            <label for="itemPrice">Price *</label>
            <div class="d-flex" style="gap: 2px">
              <input type="number" id="itemPrice" [(ngModel)]="newItem.price" (input)="onInputChange('price', +$event.target.value)" name="itemPrice" class="form-control" placeholder="0.00" step="0.01" min="0" required />
              <input type="number" *ngIf="newItem.type === 'range'" id="itemPriceMax" [(ngModel)]="newItem.priceMax" (input)="onInputChange('priceMax', +$event.target.value)" name="itempriceMax" class="form-control" placeholder="0.00" step="0.01" min="0" required />
            </div>
          </div>

          <div class="form-group">
            <label for="itemUnit">Unit *</label>
            <input type="text" id="itemUnit" [(ngModel)]="newItem.unit" (input)="onInputChange('unit', $event.target.value)" name="itemUnit" class="form-control" placeholder="e.g., piece, hour, kg" required />
          </div>
        </div>

        <div class="form-group">
          <label for="itemType">Type</label>
          <select id="itemType" [(ngModel)]="newItem.type" name="itemType" class="form-control p-0" (change)="onTypeChange()">
            <option value="number">Number</option>
            <option value="range">Range</option>
          </select>
        </div>
      </form>
    </div>

    <div class="add-item-modal__footer">
      <button type="button" class="btn btn-primary" (click)="addItem()">Add Item</button>
    </div>
  </div>
</ng-template>
